import { formatISO } from 'date-fns';
import { cast, types } from 'mobx-state-tree';
import moment from 'moment';
import { api } from 'src/api';
import { toJS } from 'mobx';
import { createAsync } from 'src/utils/asyncModel';
import { NOTIFICATION_DEFAULT } from 'src/constants/notifications';
const getAllNotificationsAsync = createAsync(() => {
  return async function getAllNotifications(options) {
    const resp = await api.Notifications.getAllNotifications(options);
    this.setNotificationList(resp.response);
    return resp;
  };
});
const createNewNotificationAsync = createAsync(body => {
  return async function createNewNotification(options) {
    const resp = await api.Notifications.createNewNotification(body, options);
    return resp;
  };
});
const getSpecificNotificationsAsync = createAsync(body => {
  return async function getSpecificNotifications(options) {
    const resp = await api.Notifications.getSpecificNotifications(body, options);
    this.setNewNotification(resp.response);
    return resp;
  };
});
const putSpecificNotificationsAsync = createAsync(body => {
  return async function putSpecificNotifications(options) {
    const resp = await api.Notifications.putSpecificNotifications(body, options);
    return resp;
  };
});
const deleteSpecificNotificationsAsync = createAsync(body => {
  return async function deleteSpecificNotifications(options) {
    const resp = await api.Notifications.deleteSpecificNotifications(body, options);
    return resp;
  };
});
const publishNotificationAsync = createAsync(body => {
  return async function publishNotification(options) {
    const resp = await api.Notifications.publishNotification(body, options);
    return resp;
  };
});
const unpublishNotificationAsync = createAsync(body => {
  return async function unpublishNotification(options) {
    const resp = await api.Notifications.unpublishNotification(body, options);
    return resp;
  };
});
const getPendingNotificationsAsync = createAsync(() => {
  return async function getPendingNotifications(options) {
    var _resp$response;
    const resp = await api.Notifications.getPendingNotifications(options);
    this.resetCurrentToS();
    const pending = (_resp$response = resp === null || resp === void 0 ? void 0 : resp.response) !== null && _resp$response !== void 0 ? _resp$response : [];
    const tosIdx = pending.findIndex(item => item.appearanceType === 'TermsOfServicesModal');
    if (tosIdx >= 0) {
      const tosData = {
        id: pending[tosIdx].id,
        title: pending[tosIdx].title,
        body: pending[tosIdx].body,
        termsOfConditions: !!pending[tosIdx].termsOfConditions ? true : false,
        privacyPolicy: !!pending[tosIdx].privacyPolicy ? true : false,
        userAcknowledgement: !!pending[tosIdx].userAcknowledgement ? true : false
      };
      this.setCurrentToS(tosData);
    }
    this.setPendingBanners(pending.filter(item => item.appearanceType === 'Banner'));
    return resp;
  };
});
const viewNotificationAsync = createAsync(body => {
  return async function viewNotification(options) {
    const resp = await api.Notifications.viewNotification(body, options);
    return resp;
  };
});
const acknowledgementNotificationAsync = createAsync(body => {
  return async function acknowledgementNotification(options) {
    const resp = await api.Notifications.acknowledgementNotification(body, options);
    return resp;
  };
});
const Notification = types.model({
  id: types.string,
  title: types.maybeNull(types.string),
  body: types.maybeNull(types.string),
  startDateOnly: types.maybeNull(types.string),
  endDateOnly: types.maybeNull(types.string),
  showButton: types.boolean,
  buttonTitle: types.maybeNull(types.string),
  buttonUrl: types.maybeNull(types.string),
  notificationType: types.maybeNull(types.union(types.number, types.string)),
  appearanceType: types.maybeNull(types.union(types.number, types.string)),
  termsOfConditions: types.maybeNull(types.string),
  privacyPolicy: types.maybeNull(types.string),
  userAcknowledgement: types.maybeNull(types.string),
  isPublished: types.boolean
});
const NewNotification = types.model({
  appearanceType: types.maybeNull(types.union(types.number, types.string)),
  type: types.string,
  title: types.string,
  body: types.string,
  button: types.string,
  buttonTitle: types.maybeNull(types.string),
  buttonLink: types.maybeNull(types.string),
  dates: types.string,
  startDateOnly: types.string,
  endDateOnly: types.maybeNull(types.string),
  termsOfConditions: types.maybeNull(types.boolean),
  privacyPolicy: types.maybeNull(types.boolean),
  userAcknowledgement: types.maybeNull(types.boolean)
});
const PendingBanner = types.model({
  id: types.string,
  title: types.maybeNull(types.string),
  body: types.maybeNull(types.string),
  showButton: types.optional(types.boolean, false),
  buttonTitle: types.maybeNull(types.string),
  buttonUrl: types.maybeNull(types.string),
  notificationType: types.maybeNull(types.union(types.number, types.string))
});
const TosNotification = types.model({
  id: types.string,
  title: types.string,
  body: types.string,
  termsOfConditions: types.maybeNull(types.boolean),
  privacyPolicy: types.maybeNull(types.boolean),
  userAcknowledgement: types.maybeNull(types.boolean)
});
const NotificationsStore = types.model('NotificationsStore', {
  viewNotificationAsync,
  getAllNotificationsAsync,
  publishNotificationAsync,
  createNewNotificationAsync,
  unpublishNotificationAsync,
  getPendingNotificationsAsync,
  getSpecificNotificationsAsync,
  putSpecificNotificationsAsync,
  deleteSpecificNotificationsAsync,
  acknowledgementNotificationAsync,
  notificationListValue: types.optional(types.array(Notification), []),
  newNotification: types.optional(NewNotification, {
    appearanceType: 'banner',
    type: 'success',
    title: NOTIFICATION_DEFAULT.title,
    body: NOTIFICATION_DEFAULT.body,
    button: 'hidden',
    buttonTitle: NOTIFICATION_DEFAULT.buttonTitle,
    buttonLink: NOTIFICATION_DEFAULT.buttonLink,
    dates: 'start',
    startDateOnly: formatISO(moment().toDate()).split('T')[0],
    endDateOnly: formatISO(moment().add(2, 'days').toDate()).split('T')[0],
    termsOfConditions: false,
    privacyPolicy: false,
    userAcknowledgement: false
  }),
  currentTos: types.optional(types.maybeNull(TosNotification), null),
  pendingBannersValue: types.optional(types.array(PendingBanner), [])
}).views(store => ({
  get notificationList() {
    return toJS(store.notificationListValue);
  },
  get pendingBanners() {
    return toJS(store.pendingBannersValue);
  }
})).actions(store => ({
  setCurrentToS(data) {
    try {
      store.currentTos = data;
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  resetCurrentToS() {
    try {
      store.currentTos = null;
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  setPendingBanners(data) {
    try {
      store.pendingBannersValue = cast((data !== null && data !== void 0 ? data : []).map(item => {
        var _item$title, _item$body, _item$buttonTitle, _item$buttonUrl, _item$notificationTyp;
        return {
          id: item.id,
          title: (_item$title = item.title) !== null && _item$title !== void 0 ? _item$title : null,
          body: (_item$body = item.body) !== null && _item$body !== void 0 ? _item$body : null,
          showButton: !!item.showButton,
          buttonTitle: (_item$buttonTitle = item.buttonTitle) !== null && _item$buttonTitle !== void 0 ? _item$buttonTitle : null,
          buttonUrl: (_item$buttonUrl = item.buttonUrl) !== null && _item$buttonUrl !== void 0 ? _item$buttonUrl : null,
          notificationType: (_item$notificationTyp = item.notificationType) !== null && _item$notificationTyp !== void 0 ? _item$notificationTyp : null
        };
      }));
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  resetPendingBanners() {
    try {
      store.pendingBannersValue = cast([]);
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  removePendingBanner(id) {
    try {
      const bannerIndex = store.pendingBannersValue.findIndex(item => item.id === id);
      if (bannerIndex < 0) return;
      store.pendingBannersValue.splice(bannerIndex, 1);
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  changeNewNotification(param, value) {
    try {
      store.newNotification[param] = value;
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  resetNewNotification() {
    try {
      store.newNotification = {
        appearanceType: 'banner',
        type: 'success',
        title: NOTIFICATION_DEFAULT.title,
        body: NOTIFICATION_DEFAULT.body,
        button: 'hidden',
        buttonTitle: NOTIFICATION_DEFAULT.buttonTitle,
        buttonLink: NOTIFICATION_DEFAULT.buttonLink,
        dates: 'start',
        startDateOnly: formatISO(moment().toDate()).split('T')[0],
        endDateOnly: formatISO(moment().add(2, 'days').toDate()).split('T')[0],
        termsOfConditions: false,
        privacyPolicy: false,
        userAcknowledgement: false
      };
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  setNewNotification(data) {
    try {
      store.newNotification = {
        appearanceType: data.appearanceType.toLocaleLowerCase(),
        type: data.notificationType.toLocaleLowerCase(),
        title: data.title,
        body: data.body,
        button: data.showButton ? 'visible' : 'hidden',
        buttonTitle: data.buttonTitle,
        buttonLink: data.buttonUrl,
        dates: !!data.endDateOnly ? 'start-end' : 'start',
        startDateOnly: data.startDateOnly,
        endDateOnly: data.endDateOnly,
        termsOfConditions: data.termsOfConditions ? true : false,
        privacyPolicy: data.privacyPolicy ? true : false,
        userAcknowledgement: data.userAcknowledgement ? true : false
      };
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  },
  setNotificationList(data) {
    try {
      store.notificationListValue = cast([]);
      store.notificationListValue = cast(data);
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  }
}));
export const notifications = types.optional(NotificationsStore, {});